export const ROUTES = {
  // Public Routes
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  RESOURCES: '/resources',
  THANK_YOU: '/thank-you',
  QR_CAPTURE: '/qr/:campaignSlug',

  // Services
  SERVICES: {
    OVERVIEW: '/services',
    CLOUD_SERVICES: '/services/cloud-services',
    CLOUD_MIGRATION: '/services/cloud-migration',
    FINOPS: '/services/cloud-cost-optimization-finops',
    SECURITY_GOVERNANCE: '/services/cloud-security-governance',
    GENAI_READINESS: '/services/genai-readiness',
    CYBERSECURITY: '/services/cybersecurity',
    MANAGED_SERVICES: '/services/managed-services',
    DEVOPS: '/services/devops-automation',
    DATA_ANALYTICS: '/services/data-analytics',
    BACKUP: '/services/backup-recovery',
    LEARNING: '/services/enterprise-learning',
    AWS: '/services/aws-consulting',
    AZURE: '/services/azure-consulting',
  },

  // Location landing pages
  LOCATIONS: {
    NOIDA: '/locations/noida',
    LUCKNOW: '/locations/lucknow',
  },

  // Calculator
  CALCULATOR: '/resources/cloud-migration-calculator',

  // Customer Segment Routes
  SOLUTIONS: {
    STARTUPS: '/solutions/startups',
    SMB_MSME: '/solutions/smb-msme',
    ENTERPRISES: '/solutions/enterprises',
  },

  // Portal Routes
  PORTAL: {
    HOME: '/portal',
    MIGRATION: '/portal/migration',
    COMPLIANCE: '/portal/compliance',
    OPTIMIZATION: '/portal/optimization',
    MANAGED_SERVICES: '/portal/managed-services',
    ADVISORY: '/portal/advisory',
    STRATEGY: '/portal/strategy',
    BACKUP: '/portal/backup',
    LEADS: '/portal/leads',
  }
};
